import {
  ApolloClient,
  ApolloProvider,
  NormalizedCacheObject,
} from '@apollo/client';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { lazyRoute } from '@eluve/app-router-utils';
import { LoadingIndicator } from '@eluve/components';

// Deferred — patient intake is a standalone surface, not part of app startup.
const AvatarIntakePage = lazyRoute(
  'AvatarIntakePage',
  () => import('@eluve/frontend-feature-avatar'),
);

export const createPatientRoutes = (
  path: string,
  client: ApolloClient<NormalizedCacheObject>,
) => {
  return [
    {
      path,
      element: (
        <Suspense fallback={<LoadingIndicator size="xl" />}>
          <ApolloProvider client={client}>
            <Outlet />
          </ApolloProvider>
        </Suspense>
      ),
      children: [
        {
          path: ':tenantId/:appointmentId',
          element: <AvatarIntakePage />,
        },
      ],
    },
  ];
};
